import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { SystemConfigStructureItemType } from 'src/types/systemConfigDetail';

export interface TopBlockPropsType {
    permissionUpdate: boolean;
    permissionUpdateStructure: boolean;
    editStructureData?: SystemConfigStructureItemType;
    handleSave: () => void;
    handleNewStructureData: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        label: translate('systemConfigDetail.newStructureItem'),
                        onClick: () => {
                            props.handleNewStructureData();
                        },
                        hidden: !props.permissionUpdateStructure || !props.editStructureData,
                    },
                    {
                        label: translate('systemConfigDetail.save'),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: !props.permissionUpdate,
                        'data-testid': 'system-config-save-btn',
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
